import { create } from 'zustand';
import { getFxRates } from '@/api/fx';

/**
 * 汇率表。多个页面共用一份，**整个会话只取一次**。
 *
 * 放进 store 而不是每个页面各自请求：汇率对所有行、所有页面都一样，
 * 服务端已经缓存了一小时，客户端再各拉各的只是白白多几个请求。
 *
 * 🔴 拿不到汇率**不是错误**：人民币参考金额只是锦上添花，失败就不显示它，
 * 绝不能让一个第三方汇率接口挂掉导致打款页面报错或打不开。
 */
interface FxState {
  rates: Record<string, number> | null;
  fetchedAt: string | null;
  loading: boolean;
  /** 取过一次（无论成功失败）就不再自动重试，避免每次进页面都打一遍失败的接口。 */
  attempted: boolean;
  load: () => Promise<void>;
}

export const useFxStore = create<FxState>((set, get) => ({
  rates: null,
  fetchedAt: null,
  loading: false,
  attempted: false,

  load: async () => {
    if (get().attempted || get().loading) return;
    set({ loading: true });
    try {
      const res = await getFxRates();
      set({ rates: res.rates, fetchedAt: res.fetchedAt });
    } catch {
      // 静默失败：参考金额不显示即可，不打扰用户
      set({ rates: null });
    } finally {
      set({ loading: false, attempted: true });
    }
  },
}));
